import React from "react";
import BaseModal from "../../../../components/ui/BaseModal";
import TaxInformation from "../../../CompleteYourProfile/Forms/TaxInformation";

const AddEditTaxInformationModal = ({
  open,
  close,
  refetchMe,
  australianBusinessNumber,
  gstPercentage,
  foreignContractor,
}) => {
  return (
    <BaseModal
      className="-top-[200px] overflow-auto"
      open={open}
      close={close}
      style={{ width: "1060px" }}
    >
      <div className="py-4 px-8">
        <div className="flex justify-between items-center border-b-2 pb-1">
          <h5 className="text-dark font-normal ">Tax Information</h5>
        </div>
      </div>

      <div className="px-2 pb-4">
        <TaxInformation
          reFetchUser={refetchMe}
          close={close}
          taxInformation={australianBusinessNumber}
          gstPercentage={gstPercentage}
          foreignContractor={foreignContractor}
          mode="USER_SETTINGS"
        />
      </div>
    </BaseModal>
  );
};

export default AddEditTaxInformationModal;
